export const customStyles = {
  facetSectionCases: {
    color: '#0B7562',
    backgroundColor: '#FFFFFF',
    border: '1px solid #898989',
  },
  localFindBackground: {
    color: '#244B44',
    backgroundColor: '#DCEFEC',
    border: '1px solid #0B7562',
  },
  facetSectionDemographics: {
    color: '#0E6292',
    backgroundColor: '#FFFFFF',
    border: '1px solid #898989',
  },
  facetSectionDemographicsBackground: {
    color: '#0E3151',
    backgroundColor: '#DCE9EF',
    border: '1px solid #5FA5C5',
  },
  facetSectionStudy: {
    color: '#942A90',
    backgroundColor: '#FFFFFF',
    border: '1px solid #898989',
  },
  facetSectionStudyBackground: {
    color: '#0E3151',
    backgroundColor: '#F4E7F3',
    border: '1px solid #942A90',
  },
  facetSectionDataAccess: {
    color: '#A35719',
    backgroundColor: '#FFFFFF',
    border: '1px solid #898989',
  },
  facetSectionDataAccessBackground: {
    color: '#0E3151',
    backgroundColor: '#F3ECE5',
    border: '1px solid #A35719',
  },
  facetSectionSamples: {
    color: '#0E6292',
    backgroundColor: '#FFFFFF',
    border: '1px solid #898989',
  },
  facetSectionSamplesBackground: {
    color: '#0E3151',
    backgroundColor: '#DCE9EF',
    border: '1px solid #5FA5C5',
  },
  facetSectionGenomic: {
    color: '#942A90',
    backgroundColor: '#FFFFFF',
    border: '1px solid #898989',
  },
  facetSectionGenomicBackground: {
    color: '#0E3151',
    backgroundColor: '#F4E7F3',
    border: '1px solid #942A90',
  },
  facetSectionImaging: {
    color: '#A35719',
    backgroundColor: '#FFFFFF',
    border: '1px solid #898989',
  },
  facetSectionImagingBackground: {
    color: '#0E3151',
    backgroundColor: '#F3ECE5',
    border: '1px solid #A35719',
  },
  facetSectionDiagnosis: {
    color: '#0E6292',
    backgroundColor: '#FFFFFF',
    border: '1px solid #898989',
  },
  facetSectionDiagnosisBackground: {
    color: '#0E3151',
    backgroundColor: '#DCE9EF',
    border: '1px solid #5FA5C5',
  },
  facetSectionFiles: {
    color: '#942A90',
    backgroundColor: '#FFFFFF',
    border: '1px solid #898989',
  },
  facetSectionFilesBackground: {
    color: '#0E3151',
    backgroundColor: '#F4E7F3',
    border: '1px solid #942A90',
  },
  facetSectionProteomic: {
    color: '#A35719',
    backgroundColor: '#FFFFFF',
    border: '1px solid #898989',
  },
  facetSectionProteomicBackground: {
    color: '#0E3151',
    backgroundColor: '#F3ECE5',
    border: '1px solid #A35719',
  },
  facetSectionCancerNanotechnology: {
    color: '#0E6292',
    backgroundColor: '#FFFFFF',
    border: '1px solid #898989',
  },
  facetSectionCancerNanotechnologyBackground: {
    color: '#0E3151',
    backgroundColor: '#DCE9EF',
    border: '1px solid #5FA5C5',
  },
  operators: {
    fontSize: '10px',
  },
  clearQueryButton: {
    margin: '1px',
    marginLeft: -6,
    fontWeight: 600,
    fontSize: '13px',
    color: '#fff',
    borderRadius: '15px',
    fontFamily: 'Nunito',
    lineHeight: '22.75px',
    boxSizing: 'border-box',
    backgroundColor: '#757575',
    textTransform: 'capitalize',
    border: '1px solid #B4B4B4',
    padding: '1px 5px 0px 6px',
    '&:hover': {
      backgroundColor: '#757575',
    },
  },
};

